import { CountryRegionData } from 'react-country-region-selector'

// react-country-region-selector v4 exports the dataset as a module namespace
// ({ default: [...] }) instead of the bare array that v3 exported. The row
// format - [countryName, countryShortCode, 'Region~CODE|...'] - is unchanged.
// Normalise here so call sites keep working if upstream reverts the wrapper.
export const countryRegionData = Array.isArray(CountryRegionData)
  ? CountryRegionData
  : CountryRegionData.default
